import React from 'react'
import {Line} from 'react-chartjs-2';
import {Col, Row, Typography} from 'antd'

const {Title} = Typography

const LineChart = ({coinHistory, coinName, currentPrice}) => {
    
    const coinPrice = [];
    const coinTimestamps = [];
    
    for(let i = 0; i < coinHistory?.data?.history?.length; i++){
        coinPrice.push(coinHistory.data.history[i].price)
        coinTimestamps.push(new Date(coinHistory.data.history[i].timestamp).toLocaleDateString())
    }
    // console.log(coinTimestamps)
    // console.log(coinPrice)

    const data = {
        labels: coinTimestamps,
        datasets:[
            {
                label: 'Price in USD',
                data: coinPrice,
                fill: false,
                backgroundColor: '#0071bd',
                borderColor: '#0071bd'
            }
        ]
    }

    const options = {
        scales: {
            Yaxis:[
                {
                    ticks: {
                        beginAtZero: true,
                    }
                }
            ]
        }
    }

    return (
        <>
            <Row className="chart-header">
                <Title level={2} className="chart-title">
                    {coinName}
                </Title>
                <Col className="price-container">
                    <Title level={5} className="price-change">{coinHistory?.data?.change}%</Title>
                    <Title level={5} className="current-price">Current {coinName} Price: ${currentPrice}</Title>
                </Col>
            </Row>
            <Line data={data} options={options}></Line>
        </>
    )
}

export default LineChart
